import {arahubAPI} from "config/axios";
import {API_ANALYTICS_URL} from "config";
import {mockResolve} from "helpers";
import {addDays, format} from "date-fns";

const ROUTE = 'spot';

const getSpots=async(query)=>{
    try{
        const {data} = await arahubAPI.get(`${API_ANALYTICS_URL}${ROUTE}`,{
            params:{
                page: query.page,
                size: query.size,
                date_from: query.date_from,
                date_to: query.date_to,
                company_id: query.company_id,
            }
        });
        return data;
    }catch(err){
        return Promise.reject(err.response);
    }
}

const getSpotById=async(spot_id)=>{
    try{
        const {data} = await arahubAPI.get(`${API_ANALYTICS_URL}${ROUTE}/${spot_id}`);
        return data;
    }catch(err){
        return Promise.reject(err.response);
    }
    // return mockResolve(true,500,mock); /** TEST MOCK */
}

const getSpotReport=async(query)=>{
    const{
        date_from,
        date_to,
        spotNames,
    }=query;
    const _spotNames = spotNames.map(i=>`spot_name=${i}`).join('&');
    try{
        const {data} = await arahubAPI.get(`${API_ANALYTICS_URL}${ROUTE}/report?${_spotNames}`,{
            responseType:'blob',
            params:{
                date_from,
                date_to,
            }
        });
        const href = URL.createObjectURL(data);
        const link = document.createElement('a');
        const fileName = `spot_report_${format(new Date(),"yyyy-MM-dd_HH:mm",)}`;
        link.href = href;
        link.setAttribute('download', fileName);

        return link;
    }catch(err){
        return Promise.reject(err.response);
    }
    // return mockResolve(true,500,{"OK":"OK"}); /** TEST MOCK */
}

const spotService={
    getSpots,
    getSpotById,
    getSpotReport,
}

export default spotService;